import { Dialog } from '@base-ui-components/react/dialog'
import { cn } from '../../utils/cn'
import { useDialogContext } from './dialog-context'

export function DialogPopup({ children, className, ...props }: DialogPopup.Props) {
  const { dismissible } = useDialogContext()
  return (
    <Dialog.Portal>
      <Dialog.Backdrop className="fixed inset-0 bg-black/40 transition-all duration-150 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0" />
      <Dialog.Popup
        className="group/dialog-popup fixed inset-0 h-dvh scale-[calc(1-0.1*var(--nested-dialogs))] outline-none transition-all duration-150 data-[ending-style]:scale-95 data-[starting-style]:scale-95 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0"
        {...props}
      >
        <div className="no-scrollbar absolute inset-0 h-dvh overflow-y-auto">
          <div className="relative flex min-h-dvh flex-col">
            {dismissible && (
              <Dialog.Close className="absolute inset-0" render={<div />} tabIndex={-1} />
            )}
            <div className="m-auto w-full">
              <div
                className={cn(
                  'bg-background relative mx-auto my-[3rem] flex w-[calc(100%-4rem)] max-w-sm flex-col gap-4 overflow-hidden rounded-xl p-6 text-gray-900 shadow-xl',
                  className
                )}
              >
                {children}
                <div className="pointer-events-none absolute inset-0 bg-black/10 opacity-0 transition-opacity duration-150 group-data-[has-nested-dialogs]/dialog-popup:opacity-100" />
              </div>
            </div>
          </div>
        </div>
      </Dialog.Popup>
    </Dialog.Portal>
  )
}

export namespace DialogPopup {
  export interface Props extends Dialog.Popup.Props {}
}
